import { Modal, message, Upload, Button, Input, Radio } from "antd";
import React, { useState, useCallback } from "react";

import { controller } from "../../controller";

import upload from "../../assets/icons/export.svg";

export default function CreateInsuranceModal({ showRequestModal, setShowRequestModal }) {
  const [files, setFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [predeterminationAndPostPaymentState, setPredeterminationAndPostPaymentState] = useState("predetermination");

  const radioOptions = [
    { label: "Predetermination", value: "predetermination" },
    { label: "Post Payment", value: "post_payment" },
  ];

  const checkFileType = (file) => {
    const isPDF = file.type === "application/pdf";
    if (!isPDF) {
      message.error("Please upload only PDF files");
      return Upload.LIST_IGNORE;
    }
    return false;
  };

  const handleSendRequest = async () => {
    const formData = new FormData();
    formData.append("name", title);
    formData.append("insurance_treatment_estimate", predeterminationAndPostPaymentState === "post_payment" ? false : true);
    files && files.length > 0 && files.map((file) => formData.append("files", file.originFileObj));
    formData.append("office", localStorage.getItem("selectedOffice"));

    try {
      setIsUploading(true);
      const response = await controller.uploadNewInsurnaces(formData);

      if (response.status < 250) {
        message.success("Request sent successfully!");

        if (response.status < 250) {
          setFiles([]);
          setTitle("");
          setShowRequestModal(false);
        }
      }
    } catch (err) {
      message.error("Something went wrong while uploading files.");
      console.error(err);
    }

    setIsUploading(false);
  };

  const handleUploadFiles = useCallback((e) => {
    const uploadedFiles = e.fileList;

    // Filter out duplicates based on file name and other unique properties
    const uniqueFiles = uploadedFiles.filter(
      (newFile, index, self) => index === self.findIndex((f) => f.name === newFile.name && f.size === newFile.size)
    );

    // Update state with unique files
    setFiles(uniqueFiles);
  }, []);

  return (
    <Modal title="New Request" open={showRequestModal} onCancel={() => setShowRequestModal(false)} style={{ padding: 10 }} width={600} footer={null}>
      <p style={{ color: "#848696" }}>
        Please upload the files that need to be sent for further review. Once uploaded, the files will be processed and sent to the insurance company
        for evaluation.
      </p>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <p>Request Type</p>

        <Radio.Group
          value={predeterminationAndPostPaymentState}
          options={radioOptions}
          disabled={isUploading}
          onChange={(e) => setPredeterminationAndPostPaymentState(e.target.value)}
          style={{ display: "flex", alignItems: "center", gap: 20 }}
        />
      </div>

      <div style={{ marginTop: 30 }}>
        <p>Request File</p>

        <Upload.Dragger
          name="file"
          multiple={true}
          fileList={files}
          beforeUpload={checkFileType}
          onChange={handleUploadFiles}
          disabled={isUploading}
          style={{ backgroundColor: "#ffffff", padding: "30px 10px" }}
        >
          <p className="ant-upload-drag-icon">
            <img src={upload} alt="upload" />
          </p>
          <p className="ant-upload-hint">
            Darg and drop or <span style={{ color: "#6b43b5", fontSize: 18 }}>Browse</span> your files
          </p>
        </Upload.Dragger>
      </div>

      <div style={{ marginTop: 30, marginBottom: 20 }}>
        <p>Request Title</p>

        <Input placeholder="Enter Title" disabled={isUploading} onChange={(e) => setTitle(e.target.value)} value={title} />
      </div>

      <Button
        loading={isUploading}
        type="primary"
        style={{ width: "100%", padding: "20px", fontSize: 18 }}
        disabled={files.length === 0 || title === ""}
        onClick={handleSendRequest}
      >
        Request
      </Button>
    </Modal>
  );
}
